<template>
  <div class="home-mantle">
    <div
      class="home-mantle__image"
    >
      <contentful-image
        :item="contentfulImage('pictureday-homepage-2023-v01-mantle-image')"
        class="responsive-img"
      />
    </div>
    <h1 class="home-mantle__lede">
      <contentful-text
        :item="contentfulText('pictureday-homepage-2023-v01-mantle-lede')"
        :render-inline="true"
      />
    </h1>
  </div>
</template>

<script>
export default {
  name: 'HomeMantle',
  computed: {
    content () {
      return this.$store.state.pageContent
    }
  }
}
</script>

<style lang="scss" scoped>
.home-mantle {
  &__lede {
    background-color: #000;
    color: #fff;
    font-family: $font-barlow-condensed;
    font-size: 1.5rem;
    font-weight: 600;
    padding: 0.8rem 0;
    text-align: center;
    text-transform: uppercase;
    width: 100%;

    @media screen and (min-width: $screen-sm-min) {
      font-size: 3.75rem;
      line-height: 3.75rem;
      padding: 1.2rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentSections/HomeMantle.vue